"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mainLogger = void 0;
var _logger = require("@ori/logger");
var _constants = require("./constants");
const mainLogger = exports.mainLogger = new _logger.Logger(_constants.APP_NAME);
